import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { BehaviorSubject, Observable } from 'rxjs';
import { AppService } from 'src/app/app.service';
import { messageService } from 'src/app/message.service';
import { SessionTimeoutService } from 'src/app/session-timeout-dialog/session-timeout.service';
import { SuccessSnackbarComponent } from 'src/app/support/success-snackbar/success-snackbar.component';
import { TimeIntegrityService } from 'src/app/time-integrity.service';

@Injectable({
  providedIn: 'root'
})
export class OneQmsAuthService {

  private readonly oneQmsChannel = new BroadcastChannel('one-qms-channel');
  private readonly loggedIn$ = new BehaviorSubject<boolean>(false);
  private isForcedLogout = false;

  constructor(
    private readonly router: Router,
    private readonly dialog: MatDialog,
    private readonly snackBar: MatSnackBar,
    private readonly appService: AppService,
    private readonly message: messageService,
    private readonly msalService: MsalService,
    private readonly timeIntegrityService: TimeIntegrityService,
  ) {
    this.oneQmsBroadcastListener();
  }

  initializeAuth(): Promise<void> {
    console.log("AUTH SERVICE CHECKING");
    return new Promise((resolve) => {
      this.validateSession().subscribe({
        next: (res: any) => {
          if (res.status === 'SUCCESS') {
            console.log('SESSION RESTORED');
            if (!this.message.getOrgId()) { this.message.setOrgId(res.data.orgId) }
            if (!this.message.getUserId()) { this.message.setUserId(res.data.userId) }
            this.router.navigate(['/dashboard']);
          } else {
            console.log('NO SESSION');
          }
          resolve();
        },
        error: (err) => {
          if (err.status === 401) {
            console.log('NO SESSION');
          } else {
            console.error('Network/Server Error', err);
          }
          resolve();
        }
      });
    });
  }

  validateSession() {
    return this.appService.validateSession();
  }

  loginSuccess(): void {
    this.loggedIn$.next(true);
  }

  isLoggedIn$(): Observable<boolean> {
    return this.loggedIn$.asObservable();
  }

  logout(from?: string) {
    this.oneQmsChannel.postMessage({ type: 'LOGOUT' });

    this.loggedIn$.next(false);
    this.dialog.closeAll();
    this.timeIntegrityService.stopSilentChecks();

    this.message.breadcrumbData = {};
    this.message.message = [];

    if (localStorage.getItem("adEnabled") == "Y") {
      this.msalService.instance.clearCache();
      this.routeToAdLogin(from);
      this.msalService.logout().subscribe({
        next: () => {
          this.routeToLogin(from);
        },
        error: (error) => {
          console.error('Logout error:', error);
        }
      });

    } else if (localStorage.getItem("loginNonAd") == "Y") {
      this.routeToLogin(from);


    } else {
      this.routeToLogin(from);
      localStorage.clear();
    }
  }

  private routeToLogin(from?: string): void {
    this.appService.logOutUser().subscribe((data: any) => {
      if (localStorage.getItem("loginNonAd") != "Y") {
        localStorage.clear();
        from == 'program' && this.showSnackBar("Session Timeout Expired", 'N');
        from == 'time-drift' && this.showSnackBar("System time zone inconsistency detected. For security reasons, you’ve been logged out", 'E');
        this.router.navigate(['/login']);

      } else if (localStorage.getItem("loginNonAd") == "Y") {
        localStorage.removeItem("tokenId");
        this.router.navigate(['/loginorg']);
      }
    });
  }

  private routeToAdLogin(from?: string): void {
    this.appService.logOutUser().subscribe((data: any) => {
      localStorage.removeItem("tokenId");
      this.router.navigate([localStorage.getItem("adapplicationUrl")]);
    });
  }

  forceLogoutFromAnotherTab(): void {

    if (this.isForcedLogout) { return; }

    this.isForcedLogout = true;
    this.loggedIn$.next(false);
    this.dialog.closeAll();
    this.timeIntegrityService.stopSilentChecks();
    localStorage.clear();
    this.router.navigate(['/login']);
    this.showSnackBar('Logged out from another tab', 'N');
  }

  private oneQmsBroadcastListener(): void {
    this.oneQmsChannel.onmessage = (event) => {
      switch (event.data?.type) {
        case 'LOGOUT':
          this.forceLogoutFromAnotherTab();
          break;
      }
    };
  }

  snackbarRef: any;
  showSnackBar(message: string, type: string) {
    let messageType: string;

    if (type === 'S') {
      messageType = 'Success';
    } else if (type === 'E') {
      messageType = 'Error';
    } else {
      messageType = 'Notice';
    }

    this.snackbarRef = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
      duration: type === 'S' ? 5000 : undefined,
      data: {
        message,
        type: messageType,
        buttonLabel: 'Ok',
        pageName: this.message.breadcrumbData.thirdLevel ? this.message.breadcrumbData.thirdLevel : this.message.breadcrumbData.secondLevel,
      },
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: type === 'S' ? 'Success' : 'Error',
    });

    this.snackbarRef.onAction().subscribe(() => {
      this.snackbarRef.dismiss();
    });
  }

}
